import { hbs } from 'ember-cli-htmlbars';
export default hbs("{{page-title this.url.friendlyUrl}}\n{{page-title @model.name}}\n\n<Reports::ReportForm\n  @url={{this.url}}\n  @report={{@model}}\n  @logos={{this.whitelabelLogos}}\n/>")